<template lang="pug">
  v-container
    v-row
      v-col(cols="12")
        h1 Инструкции
      v-col(cols="12")
        v-card(outlined)
          v-expansion-panels(v-model="panel" max="1" accordion)
            v-expansion-panel
              v-expansion-panel-header PFDO
              v-expansion-panel-content
                ul.pa-0.pl-4.d-lg-flex(v-for="instruction in PFDO_instructions" :key="instruction.id")
                    li.insctruction.d-lg-flex
                      router-link(:to="`/instruction/${instruction.id}?pfdo=true`" target="_blank") {{ instruction.name }}
                      v-icon.ml-2.primary--text.insctruction--icon(@click="openInstructionPdf(instruction)") mdi-download
                v-progress-linear.my-4(:active="loading" indeterminate)
                v-btn.mt-4(
                  v-if="page <= pages" color="primary"
                  outlined
                  :loading="loading"
                  @click="fetchPFDOInstructions"
                ) Показать ещё
            v-expansion-panel(v-for="project in projects" :key="project.id" v-if="checkUserProject(project.id)")
              v-expansion-panel-header {{ project.name }}
              v-expansion-panel-content
                ul.pa-0.pl-4(v-for="instruction in projectInstructions" :key="instruction.id")
                   li.insctruction.d-lg-flex
                      router-link(:to="`/instruction/${instruction.id}?pfdo=true`" target="_blank") {{ instruction.name }}
                      v-icon.ml-2.primary--text.insctruction--icon(@click="openInstructionPdf(instruction)") mdi-download
                v-progress-linear.my-4(:active="loading" indeterminate)
                v-btn.mt-4(
                  v-if="projectPage <= projectPages" color="primary"
                  outlined
                  :loading="loading"
                  @click="fetchProjectInstructions"
                ) Показать ещё

</template>
<script>
import userServices from '@/services/API/user';
import { mapGetters } from 'vuex';
import directoryService from '@/services/API/_directory';

export default {
  data() {
    return {
      userProjects: [],
      panel: null,
      PFDO_instructions: [],
      projects: [
        {
          id: 1,
          name: 'НОК',
        },
        {
          id: 2,
          name: 'Мероприятия',
        },
        {
          id: 3,
          name: 'СДО',
        },
      ],
      page: 1,
      pages: 1,

      projectInstructions: [],
      projectPage: 1,
      projectPages: 1,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      'user': 'auth/getUser',
    }),
  },
  watch: {
    panel(v) {
      if (!v) { this.fetchPFDOInstructions(); return; }
      this.fetchProjectInstructions();
      this.projectInstructions = [];
      this.page = 1;
      this.pages = 1;
      this.projectPage = 1;
      this.projectPages = 1;
    },
  },
  methods: {
    openInstructionPdf(instruction) {
      window.open(instruction.pdf_url, '_blank');
    },
    checkUserProject(projectId) {
      return this.userProjects.indexOf(projectId) !== -1;
    },
    async fetchPFDOInstructions() {
      const params = {
        page: this.page,
      };
      this.loading = true;
      const response = await directoryService.getHelps({ ...params, 'expand': 'pdf_url' });
      // console.log(response);
      this.page = +response.headers['x-pagination-current-page'] + 1;
      this.pages = +response.headers['x-pagination-page-count'];
      this.PFDO_instructions = [...this.PFDO_instructions, ...response.data.data];
      this.loading = false;
    },
    async getUserProjects() {
      try {
        const response = await userServices.userMe({ 'expand': 'projects' });
        this.userProjects.push(response.data.data.projects);
      } catch (err) {
        this.$toast.error('err.response.data.result_message');
      }
    },
    async fetchProjectInstructions() {
      const params = {
        'search[system_id]': this.projects[this.panel - 1].id,
        'page': this.projectPage,

      };
      this.loading = true;
      const response = await directoryService.getServiceHelps(params);

      this.loading = false;
      this.projectPage = +response.headers['x-pagination-current-page'] + 1;
      this.projectPages = +response.headers['x-pagination-page-count'];

      this.projectInstructions = [...this.projectInstructions, ...response.data.data];
    },
  },
};
</script>

<style lang="scss" scoped>
.insctruction--icon {
  visibility: hidden;
}
// LOH никто так не называет классы
.insctruction:hover .insctruction--icon {
  visibility: visible;
}
</style>
